// 1. React and fabric. 
// 2. Store and Types. 
// 3. Scripts. 
import Credentials                                     from '../scripts/Credentials'     ;

// 10/16/2021 Paul.  Add support for user currency. 
export default class C10n
{
		public static ToCurrency(f: number): number
		{
			// 05/10/2006 Paul.  Short-circuit the math if USD. 
			// This is more to prevent bugs than to speed calculations. 
			if ( Credentials.bUSER_CurrencyUSDollars || Credentials.dUSER_CurrencyCONVERSION_RATE <= 0 )
				return f;
			return f * Credentials.dUSER_CurrencyCONVERSION_RATE;
		}

		public static FromCurrency(f: number): number
		{
			// 05/10/2006 Paul.  Short-circuit the math if USD. 
			// This is more to prevent bugs than to speed calculations. 
			if ( Credentials.bUSER_CurrencyUSDollars || Credentials.dUSER_CurrencyCONVERSION_RATE <= 0 )
				return f;
			return f / Credentials.dUSER_CurrencyCONVERSION_RATE;
		}
}

